import { ROUTE_ACCOUNT } from '@/constants/routes';
import { TOAST_UPDATE_PERSONAL_INFO } from '@/constants/toast';
import { useMe } from '@/context/me/me.context';
import { useUpdateProfile } from '@/queries/profile.queries';
import { useDisclosure, useToast } from '@cmpsr/components';
import { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useBeforeUnload, useNavigate } from 'react-router-dom';

export default function useEditPersonalInfoController() {
  const { data, refetch } = useMe();
  const updateProfileMutation = useUpdateProfile();
  const toast = useToast();
  const navigate = useNavigate();
  const { isOpen: showEditEmailModal, onOpen: onShowEditEmailModal, onClose: onHideEditEmailModal } = useDisclosure();

  function onCloseEditEmailModal() {
    onHideEditEmailModal();
    refetch();
  }

  const form = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: { name: data?.profile?.name as string, email: data?.account?.credential as string },
  });

  useBeforeUnload(
    useCallback(
      (event) => {
        if (form.formState.dirtyFields.name) {
          event.preventDefault();
        }
      },
      [form.formState.dirtyFields.name]
    )
  );

  useEffect(() => {
    if (data?.profile?.name) {
      form.setValue('name', data.profile.name);
    }
    if (data?.account?.credential) {
      form.setValue('email', data.account.credential);
    }
  }, [data, form]);

  const handleSubmit = form.handleSubmit((values) => {
    updateProfileMutation
      .mutateAsync({ name: values.name })
      .then(() => {
        toast({
          ...TOAST_UPDATE_PERSONAL_INFO,
          description: 'The info was updated successfully',
          status: 'success',
        });
        navigate(ROUTE_ACCOUNT);
      })
      .catch((error) => {
        console.error(error);
        toast({
          ...TOAST_UPDATE_PERSONAL_INFO,
          title: `Error ${error.response?.data?.statusCode ?? ''}`,
          description: error.response?.data?.message ?? error.message,
          status: 'error',
        });
      });
  });

  return { form, handleSubmit, showEditEmailModal, onShowEditEmailModal, onCloseEditEmailModal };
}
